import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If the HTML shell came from our SSG prerender step (scripts/prerender.js),
// `<html data-prerendered="true">` will be present and we hydrate the existing
// DOM. Otherwise (dev server / un-prerendered first load) we client-render.
const isPrerendered =
  typeof document !== "undefined" &&
  document.documentElement.getAttribute("data-prerendered") === "true";

if (isPrerendered && container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
